var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiService from "../../../helpers/apiService";
import configVariables from "../../../assests/config";
import { getLocalStorage, setLocalStorage } from "../../../helpers/storage";
export const getBearerToken = () => Boolean(getLocalStorage(configVariables.bearerToken));
export const createSession = (config) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let request = {
            username: config.tokenUserName,
            password: config.tokenUserPassword,
        };
        const data = yield apiService.post({
            URL: config.sessionURL + configVariables.API_URLS.session,
            brand: config.brand,
            disableConfig: true,
            data: request,
        });
        let bearer = data["headers"].authorization;
        var array = bearer.split("Bearer ");
        setLocalStorage(configVariables.bearerToken, array[1]);
        return Promise.resolve({});
    }
    catch (error) {
        return Promise.reject({
            message: configVariables.errorMessages.SOMETHING_WRONG,
        });
    }
});
export const getOriginalEmailId = (data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const createRequestURL = data.sessionURL + configVariables.API_URLS.verifyEmail + data.email;
    try {
        const response = yield apiService.get({
            URL: createRequestURL,
            brand: data.brand,
        });
        return Promise.resolve(response.data);
    }
    catch (error) {
        let message = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data.message;
        if (message === "No valid Member found") {
            message = "Incorrect username or password";
        }
        throw new Error(message);
    }
});
export const getIdCardDetails = (config) => __awaiter(void 0, void 0, void 0, function* () {
    const createRequestURL = config.sessionURL + configVariables.API_URLS.userInfo;
    try {
        const response = yield apiService.post({
            URL: createRequestURL,
            data: { email: config.email },
            brand: config.brand,
        });
        return Promise.resolve(response.data);
    }
    catch (error) {
        return error;
    }
});
